import { Control, Controller, FieldValues, Path, PathValue } from "react-hook-form";
import { UnifiedInput, UnifiedInputProps, InputType, LabelStyle } from "./unified-input";
import { useTranslateMessage } from "@/hooks/useTranslateMessage";

interface ControlledUnifiedInputProps<T extends FieldValues>
  extends Omit<UnifiedInputProps, "value" | "onChange" | "error" | "id"> {
  name: Path<T>;
  control: Control<T>;
  defaultValue?: PathValue<T, Path<T>>;
}

export const ControlledUnifiedInput = <T extends FieldValues>({
  control,
  name,
  defaultValue,
  ...inputProps
}: ControlledUnifiedInputProps<T>) => {
  const translateMessage = useTranslateMessage();
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => (
        <UnifiedInput
          {...inputProps}
          id={name}
          name={field.name}
          value={field.value}
          onChange={field.onChange}
          ref={field.ref}
          error={translateMessage(error?.message)}
        />
      )}
    />
  );
};

export type { InputType, LabelStyle };
